"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var tf = _interopRequireWildcard(require("@tensorflow/tfjs"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _Chart = _interopRequireDefault(require("./Chart"));
var _sum2 = _interopRequireDefault(require("lodash/sum"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _LearningBase2 = _interopRequireDefault(require("./LearningBase"));
var _Utils = _interopRequireDefault(require("./Utils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var classes = exports.classes = ['ai_learning_train', 'ai_learning_regression', 'regression_attr_1', 'regression_attr_2', 'regression_attr_3', 'regression_attr_4', 'regression_attr_5', 'regression_attr_6', 'ai_learning_train_chart'];
var Regression = /*#__PURE__*/function (_LearningBase) {
  function Regression() {
    var _this;
    (0, _classCallCheck2["default"])(this, Regression);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Regression, [].concat(args));
    (0, _defineProperty2["default"])(_this, "type", 'regression');
    return _this;
  }
  (0, _inherits2["default"])(Regression, _LearningBase);
  return (0, _createClass2["default"])(Regression, [{
    key: "init",
    value: function init(_ref) {
      var _this2 = this,
        _table$select,
        _table$select2,
        _table$select3;
      var name = _ref.name,
        url = _ref.url,
        result = _ref.result,
        table = _ref.table,
        trainParam = _ref.trainParam;
      this.name = name;
      this.trainParam = trainParam;
      this.result = result;
      this.table = table;
      this.trainCallback = function (value) {
        _this2.view.setValue(value);
      };
      this.trained = true;
      this.attrLength = (table === null || table === void 0 || (_table$select = table.select) === null || _table$select === void 0 || (_table$select = _table$select[0]) === null || _table$select === void 0 ? void 0 : _table$select.length) || 0;
      if (this.attrLength === 1) {
        this.chartEnable = true;
      }
      if (this.url !== url) {
        this.load(url);
        this.url = url;
      }
      this.fields = table === null || table === void 0 || (_table$select2 = table.select) === null || _table$select2 === void 0 || (_table$select2 = _table$select2[0]) === null || _table$select2 === void 0 ? void 0 : _table$select2.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      this.predictFields = table === null || table === void 0 || (_table$select3 = table.select) === null || _table$select3 === void 0 || (_table$select3 = _table$select3[1]) === null || _table$select3 === void 0 ? void 0 : _table$select3.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      if (!_Utils["default"].isWebGlSupport()) {
        tf.setBackend('cpu');
      }
    }
  }, {
    key: "generateChart",
    value: function generateChart() {
      this.chart = new _Chart["default"]({
        source: this.chartData,
        title: Lang.AiLearning.chart_title,
        description: "\n                ".concat(this.fields.map(function (field, index) {
          return "<em>".concat(Lang.AiLearning.model_attr_str, " ").concat(index + 1, "</em>: ").concat(field);
        }), "\n                <em>").concat(Lang.AiLearning.predict, "</em>").concat(this.predictFields[0], "<em>").concat(Lang.AiLearning.equation, "</em>").concat(this.result.equation, "\n            ")
      });
    }
  }, {
    key: "train",
    value: function () {
      var _train2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this3 = this;
        var _this$chart, currentEpoch, percent, _convertToTfData, inputs, outputs, _yield$_train, model, trainHistory, a, b, _yield$_train$graphDa, graphData, rsquared, normResult, _ref2, _ref2$acc, acc, accuracy, graphPoints, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.setTable();
              this.trained = false;
              currentEpoch = 0;
              percent = 0;
              this.trainCallback(1);
              _convertToTfData = convertToTfData(this.table, this.trainParam), inputs = _convertToTfData.inputs, outputs = _convertToTfData.outputs;
              _context.next = 1;
              return _train(inputs, outputs, this.trainParam, undefined, function () {
                currentEpoch = currentEpoch + 1;
                percent = (0, _floor2["default"])(currentEpoch / _this3.trainParam.epochs * 100);
                _this3.trainCallback(Math.min(percent, 100));
              });
            case 1:
              _yield$_train = _context.sent;
              model = _yield$_train.model;
              trainHistory = _yield$_train.trainHistory;
              a = _yield$_train.a;
              b = _yield$_train.b;
              _yield$_train$graphDa = _yield$_train.graphData;
              graphData = _yield$_train$graphDa === void 0 ? [] : _yield$_train$graphDa;
              rsquared = _yield$_train.rsquared;
              normResult = _yield$_train.normResult;
              this.model = model;
              _ref2 = (trainHistory === null || trainHistory === void 0 ? void 0 : trainHistory.history) || {}, _ref2$acc = _ref2.acc, acc = _ref2$acc === void 0 ? [] : _ref2$acc;
              accuracy = (0, _max2["default"])(acc) || 0;
              graphPoints = (graphData.originalPoints || []).slice(0, 1000);
              if (inputs.length == 1) {
                graphData.predictedPoints.map(function (_ref3, i) {
                  var x = _ref3.x,
                    y = _ref3.y;
                  var index = graphPoints.sort(function (a, b) {
                    return a.x - b.x;
                  }).findIndex(function (p) {
                    return p.x >= x;
                  });
                  if (index < 0 && i > 0) {
                    index = graphPoints.length - 1;
                  }
                  if (graphPoints[index]) {
                    graphPoints[index].equation = y;
                  }
                });
              }
              this.result = {
                graphData: graphPoints,
                accuracy: accuracy,
                normResult: normResult,
                rsquared: rsquared,
                equation: "Y = ".concat(a.map(function (a, i) {
                  return "".concat(addSign(a), "X<sub>").concat(i + 1, "</sub>");
                }).join(''), " ").concat(addSign(b))
              };
              this.trained = true;
              (_this$chart = this.chart) === null || _this$chart === void 0 || _this$chart.load({
                source: this.chartData,
                description: "\n                    ".concat(this.fields.map(function (field, index) {
                  return "<em>".concat(Lang.AiLearning.model_attr_str, " ").concat(index + 1, "</em> ").concat(field);
                }), "\n                    <em>").concat(Lang.AiLearning.predict, "</em> ").concat(this.predictFields[0], "<em>").concat(Lang.AiLearning.equation, "</em>").concat(this.result.equation, "\n                ")
              });
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.log('train error', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function train() {
        return _train2.apply(this, arguments);
      }
      return train;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(url) {
        var model, modelData;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return tf.loadLayersModel(url);
            case 1:
              model = _context2.sent;
              modelData = new Promise(function (resolve) {
                return model.save({
                  save: function save(data) {
                    var _data$modelTopology;
                    var layers = data === null || data === void 0 || (_data$modelTopology = data.modelTopology) === null || _data$modelTopology === void 0 || (_data$modelTopology = _data$modelTopology.config) === null || _data$modelTopology === void 0 ? void 0 : _data$modelTopology.layers;
                    if (Array.isArray(layers)) {
                      data.modelTopology.config.layers.forEach(function (layer) {
                        var _layer$config;
                        if (layer !== null && layer !== void 0 && (_layer$config = layer.config) !== null && _layer$config !== void 0 && _layer$config.name) {
                          layer.config.name = "".concat(layer.config.name, "_ws");
                        }
                      });
                    }
                    if (Array.isArray(data.weightSpecs)) {
                      data.weightSpecs.forEach(function (spec) {
                        var splits = spec.name.split('/');
                        splits[0] = "".concat(splits[0], "_ws");
                        spec.name = splits.join('/');
                      });
                    }
                    resolve(data);
                  }
                });
              });
              _context2.next = 2;
              return tf.loadLayersModel({
                load: function load() {
                  return modelData;
                }
              });
            case 2:
              this.model = _context2.sent;
              model.dispose();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function load(_x) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "convertNomalResult",
    value: function convertNomalResult() {
      var _this$result$normResu = this.result.normResult,
        inputMin = _this$result$normResu.inputMin,
        inputMax = _this$result$normResu.inputMax,
        outputMax = _this$result$normResu.outputMax,
        outputMin = _this$result$normResu.outputMin;
      if (!Array.isArray(inputMin)) {
        return this.result.normResult;
      }
      return {
        inputMin: tf.tensor1d(inputMin),
        inputMax: tf.tensor1d(inputMax),
        outputMax: tf.tensor1d(outputMax),
        outputMin: tf.tensor1d(outputMin)
      };
    }
  }, {
    key: "predict",
    value: function () {
      var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(data) {
        var _this4 = this;
        var _this$convertNomalRes, inputMin, inputMax, outputMax, outputMin, result;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              tf.engine().startScope();
              _this$convertNomalRes = this.convertNomalResult(), inputMin = _this$convertNomalRes.inputMin, inputMax = _this$convertNomalRes.inputMax, outputMax = _this$convertNomalRes.outputMax, outputMin = _this$convertNomalRes.outputMin;
              result = tf.tidy(function () {
                var convertedData;
                if (Array.isArray(data)) {
                  convertedData = tf.tensor2d([data]);
                } else {
                  convertedData = tf.tensor1d([data]);
                }
                convertedData = convertedData.sub(inputMin).div(inputMax.sub(inputMin));
                var preds = _this4.model.predict(convertedData).mul(outputMax.sub(outputMin)).add(outputMin);
                var _preds$dataSync = preds.dataSync(),
                  _preds$dataSync2 = (0, _slicedToArray2["default"])(_preds$dataSync, 1),
                  result = _preds$dataSync2[0];
                _this4.predictResult = (0, _floor2["default"])(result, 2);
                preds.dispose();
                return _this4.predictResult;
              });
              tf.engine().endScope();
              return _context3.abrupt("return", result);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function predict(_x2) {
        return _predict.apply(this, arguments);
      }
      return predict;
    }()
  }, {
    key: "chartData",
    get: function get() {
      var _this5 = this;
      return {
        data: {
          json: this.result.graphData,
          keys: {
            value: ['equation', 'y'],
            x: 'x'
          },
          types: {
            y: 'scatter',
            equation: 'line'
          }
        },
        options: {
          legend: {
            show: false
          },
          tooltip: {
            contents: function contents(data) {
              var _data = (0, _slicedToArray2["default"])(data, 1),
                _data$ = _data[0],
                x = _data$.x,
                value = _data$.value,
                id = _data$.id;
              return "\n                            <div class=\"chart_handle_wrapper\">\n                                ".concat(_this5.fields[0], ": ").concat(x, ", ").concat(_this5.predictFields[0], ": ").concat(value, "\n                            <div>\n                        ");
            }
          },
          line: {
            connectNull: true,
            point: false
          },
          axis: {
            x: {
              tick: {
                fit: false,
                count: 15
              }
            }
          },
          grid: {
            x: {
              show: true
            },
            y: {
              show: true
            }
          }
        }
      };
    }
  }]);
}(_LearningBase2["default"]);
var _default = exports["default"] = Regression;
function addSign(x) {
  return x < 0 ? x : "+".concat(x);
}
function convertToTfData(data, trainParam) {
  var _data$select = data.select,
    select = _data$select === void 0 ? [[0], [1]] : _data$select,
    table = data.data;
  var _select = (0, _slicedToArray2["default"])(select, 2),
    attr = _select[0],
    predict = _select[1];
  var _trainParam$epochs = trainParam.epochs,
    epochs = _trainParam$epochs === void 0 ? 1 : _trainParam$epochs,
    _trainParam$batchSize = trainParam.batchSize,
    batchSize = _trainParam$batchSize === void 0 ? 1 : _trainParam$batchSize;
  var filtered = table.filter(function (row) {
    return !select.flat().some(function (selected) {
      return (0, _isNaN2["default"])((0, _toNumber2["default"])(row[selected]));
    });
  });
  var totalDataSize = Math.ceil(filtered.length / batchSize) * epochs;
  return filtered.reduce(function (accumulator, row) {
    var _accumulator$inputs = accumulator.inputs,
      inputs = _accumulator$inputs === void 0 ? [] : _accumulator$inputs,
      _accumulator$outputs = accumulator.outputs,
      outputs = _accumulator$outputs === void 0 ? [] : _accumulator$outputs;
    return {
      inputs: attr.map(function (i, idx) {
        var arr = inputs[idx] || [];
        return [].concat((0, _toConsumableArray2["default"])(arr), [parseFloat(row[i]) || 0]);
      }),
      outputs: predict.map(function (i, idx) {
        var arr = outputs[idx] || [];
        return [].concat((0, _toConsumableArray2["default"])(arr), [parseFloat(row[i]) || 0]);
      }),
      totalDataSize: totalDataSize
    };
  }, {
    inputs: [],
    outputs: []
  });
}
function convertToTensor(inputs, outputs) {
  return tf.tidy(function () {
    var inputTensor = tf.tensor2d(inputs).transpose();
    var outputTensor = tf.tensor2d(outputs).transpose();
    var inputMax = inputTensor.max(0);
    var inputMin = inputTensor.min(0);
    var outputMax = outputTensor.max(0);
    var outputMin = outputTensor.min(0);

    // (d - min) / (max - min)
    var normalizedInputs = inputTensor.sub(inputMin).div(inputMax.sub(inputMin));
    var normalizedOutputs = outputTensor.sub(outputMin).div(outputMax.sub(outputMin));
    return {
      inputs: normalizedInputs,
      outputs: normalizedOutputs,
      inputMax: inputMax,
      inputMin: inputMin,
      outputMax: outputMax,
      outputMin: outputMin
    };
  });
}
function createModel(inputShape) {
  var model = tf.sequential();
  model.add(tf.layers.dense({
    inputShape: [inputShape],
    units: 1,
    name: 'reg_dense_ws'
  }));
  return model;
}
function trainModel(_x3, _x4, _x5, _x6, _x7, _x8) {
  return _trainModel.apply(this, arguments);
}
function _trainModel() {
  _trainModel = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(model, inputs, outputs, trainParam, onBatchEnd, onEpochEnd) {
    return _regenerator["default"].wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          model.compile({
            optimizer: tf.train.adam(trainParam.learningRate),
            loss: tf.losses.meanSquaredError,
            metrics: ['mse', 'acc', 'ce']
          });
          _context4.next = 1;
          return model.fit(inputs, outputs, {
            batchSize: trainParam.batchSize,
            epochs: trainParam.epochs,
            shuffle: trainParam.shuffle,
            validationSplit: trainParam.validationRate,
            callbacks: {
              onBatchEnd: onBatchEnd,
              onEpochEnd: onEpochEnd
            }
          });
        case 1:
          return _context4.abrupt("return", _context4.sent);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _trainModel.apply(this, arguments);
}
var TEST_POINT_COUNT = 2;
function testModel(model, normalizationData) {
  var inputMin = normalizationData.inputMin,
    inputMax = normalizationData.inputMax,
    outputMin = normalizationData.outputMin,
    outputMax = normalizationData.outputMax;
  var _tf$tidy = tf.tidy(function () {
      var xs = tf.linspace(0, 1, TEST_POINT_COUNT);
      var preds = model.predict(xs.reshape([TEST_POINT_COUNT, 1]));

      // d * (max - min) + min
      var unNormXs = xs.mul(inputMax.sub(inputMin)).add(inputMin);
      // @ts-ignore
      var unNormPreds = preds.mul(outputMax.sub(outputMin)).add(outputMin);
      return [unNormXs.dataSync(), unNormPreds.dataSync()];
    }),
    _tf$tidy2 = (0, _slicedToArray2["default"])(_tf$tidy, 2),
    xs = _tf$tidy2[0],
    preds = _tf$tidy2[1];
  return Array.from(xs).map(function (val, i) {
    return {
      x: val,
      y: preds[i]
    };
  });
}
function getR2Score(model, normResult, y) {
  var yData = y[0];
  var yHat = model.predict(normResult.inputs).mul(normResult.outputMax.sub(normResult.outputMin)).add(normResult.outputMin).dataSync();
  var yMean = yData.reduce(function (acc, cur) {
    return acc + cur;
  }) / yData.length;
  var ssr = yHat.map(function (e, index) {
    return (e - yData[index]) * (e - yData[index]);
  }).reduce(function (acc, cur) {
    return acc + cur;
  });
  var sst = yData.map(function (e) {
    return (e - yMean) * (e - yMean);
  }).reduce(function (acc, cur) {
    return acc + cur;
  });
  var r2 = 1 - ssr / sst;
  return Math.max(r2, 0);
}
function _train(_x9, _x0, _x1, _x10, _x11) {
  return _train3.apply(this, arguments);
}
function _train3() {
  _train3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(inputs, outputs, trainParam, onBatchEnd, onEpochEnd) {
    var normResult, model, history, weight, bias, inputMin, inputMax, outputMin, outputMax, o, oi, a, b, r2, graphData;
    return _regenerator["default"].wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          normResult = convertToTensor(inputs, outputs);
          model = createModel(inputs.length);
          _context5.next = 1;
          return trainModel(model, normResult.inputs, normResult.outputs, trainParam, onBatchEnd, onEpochEnd);
        case 1:
          history = _context5.sent;
          // @ts-ignore
          weight = model.layers[0].weights[0].val; // @ts-ignore
          bias = model.layers[0].weights[1].val;
          inputMin = normResult.inputMin;
          inputMax = normResult.inputMax;
          outputMin = normResult.outputMin;
          outputMax = normResult.outputMax;
          o = outputMax.sub(outputMin);
          oi = o.div(inputMax.sub(inputMin));
          a = oi.mul(weight.transpose());
          b = bias.mul(o).add(outputMin).sub(a.matMul(inputMin.expandDims(0).transpose()));
          r2 = getR2Score(model, normResult, outputs);
          graphData = {
            originalPoints: [],
            predictedPoints: []
          };
          if (inputs.length === 1) {
            graphData.originalPoints = inputs[0].map(function (e, i) {
              return {
                x: e,
                y: outputs[0][i]
              };
            });
            graphData.predictedPoints = testModel(model, normResult);
          }
          return _context5.abrupt("return", {
            model: model,
            normResult: normResult,
            trainHistory: history,
            a: Array.from(a.dataSync()).map(function (x) {
              return (0, _floor2["default"])(x, 2);
            }),
            b: (0, _floor2["default"])(b.dataSync()[0], 2),
            rsquared: (0, _floor2["default"])(r2, 2),
            graphData: graphData
          });
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _train3.apply(this, arguments);
}